import { isDefined } from "@clipboard-health/util-ts";

export function getCardType(placement: { hiringEvents?: unknown }) {
  if (isDefined(placement.hiringEvents)) {
    return "open-house";
  }

  return "interview-days";
}
